import { useLayoutEffect, useRef } from 'react'
import { dismissKeyboard, dismissPreviousKeyboard } from './keyboard'

/** Новый слой завершает ввод на фоне; автофокус внутри самого слоя сохраняется. */
export function useKeyboardBoundary(key?: string | number) {
  const ref = useRef<HTMLDivElement>(null)
  useLayoutEffect(() => {
    const boundary = ref.current
    if (!boundary) return
    if (!boundary.contains(document.activeElement)) dismissKeyboard()
    return () => {
      // Submit может закрыть окно мимо его onClose. После commit отличаем настоящее
      // удаление от StrictMode; фокус другого окна никогда не забираем.
      const active = document.activeElement
      const ownedFocus = boundary.contains(active) ? active : null
      queueMicrotask(() => {
        if (!boundary.isConnected) dismissPreviousKeyboard(ownedFocus)
      })
    }
  }, [key])
  return ref
}
